import React from 'react';
import {AgeingData} from "./AgeingData";
import ViewDataContextProvider from "../../commons/context/view/ViewDataContext.js";
import FiltersDataContextProvider from "../../commons/context/FiltersDataContext";
import FiltersStateContextProvider from '../../commons/context/FiltersStateContext';

const AgeingView = (props) => {
  
        return (
            <FiltersDataContextProvider>
              <FiltersStateContextProvider context = {props.match.params.context}>
                <ViewDataContextProvider>
                  <AgeingData/>
                </ViewDataContextProvider>
              </FiltersStateContextProvider>   
            </FiltersDataContextProvider>

        )
    }

export default AgeingView;


// WEBPACK FOOTER //
// ./src/components/ageing/AgeingView.js